import React from 'react'

const CardHeaderWithActions = ({children,title}) => {
    return (
        <>
            <div id='Header' className='flex flex-col sm:flex-row sm:items-center gap-3 rounded-2xl border border-[#f5b800]/20 bg-white px-4 py-3 shadow-[0_10px_24px_rgba(8,32,63,.04)]'>
                <div className='flex-1 flex items-center gap-2 font-black text-sm text-[#08203f]'>
                    <span className='h-5 w-1 rounded-full bg-[#f5b800]' />
                    <span>{title}</span>
                </div>
                <div className='flex items-center gap-2 justify-end'>
                    {children}
                </div>
            </div>
            <hr className='my-4 border-[#f5b800]/20'/>
        </>
    )
}

export default CardHeaderWithActions
